/**
 * ReactionPicker - a fileira de reações rápidas do WhatsApp (6 emojis) com
 * o "+" que abre a grade completa. Compartilhado pelos 3 shells.
 *
 * Props: { current, onPick(emoji|null), colors, compact }
 *  - current: emoji já aplicado pelo operador (clicar nele remove).
 */
import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { QUICK_REACTIONS, MORE_REACTIONS } from './messageActions';

const ReactionPicker = ({ current = null, onPick, colors, compact = false }) => {
  const [more, setMore] = useState(false);

  const pick = (emoji) => {
    if (!onPick) return;
    onPick(emoji === current ? null : emoji);
  };

  const cell = (emoji, size) => {
    const active = emoji === current;
    return (
      <button
        key={emoji}
        type="button"
        onClick={(e) => { e.stopPropagation(); pick(emoji); }}
        title={active ? 'Remover reação' : `Reagir com ${emoji}`}
        style={{
          width: size, height: size, borderRadius: '50%',
          border: active ? `2px solid ${colors.accentPrimary}` : '2px solid transparent',
          backgroundColor: active ? colors.bgTertiary : 'transparent',
          fontSize: size * 0.58, lineHeight: 1, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'transform 120ms',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.25)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        {emoji}
      </button>
    );
  };

  const size = compact ? 30 : 36;

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        display: 'flex', flexDirection: 'column', gap: 6,
        padding: 6, borderRadius: more ? 14 : 999,
        backgroundColor: colors.bgPrimary,
        border: `1px solid ${colors.borderColor}`,
        boxShadow: '0 8px 24px rgba(0,0,0,0.14)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {QUICK_REACTIONS.map((e) => cell(e, size))}
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setMore((v) => !v); }}
          title={more ? 'Menos' : 'Mais reações'}
          style={{
            width: size, height: size, borderRadius: '50%', border: 'none',
            backgroundColor: colors.bgTertiary, color: colors.textSecondary,
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {more ? <X size={16} /> : <Plus size={16} />}
        </button>
      </div>
      {more && (
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 2,
          maxWidth: 8 * (size - 4), padding: '2px 0',
        }}>
          {MORE_REACTIONS.map((e) => cell(e, size - 4))}
        </div>
      )}
    </div>
  );
};

export default ReactionPicker;
